"use client";

import { createContext, useContext, type PropsWithChildren } from "react";

interface FilterContext {
	sizeCharts: string[];
}

export const FilterContext = createContext<FilterContext | null>(null);

export const FilterProvider = ({ children, ...rest }: PropsWithChildren<FilterContext>) => {
	return <FilterContext value={rest}>{children}</FilterContext>;
};

export const useFilterContext = () => {
	return useContext(FilterContext);
};
